'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dStore$002dApp$002dPage from "./mealorama.-App-Router$-Store-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$StoreAppPage$() {
}
export { $c_Lmealorama_AppRouter$StoreAppPage$ as $c_Lmealorama_AppRouter$StoreAppPage$ };
$p = $c_Lmealorama_AppRouter$StoreAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$StoreAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$StoreAppPage$() {
}
export { $h_Lmealorama_AppRouter$StoreAppPage$ as $h_Lmealorama_AppRouter$StoreAppPage$ };
$h_Lmealorama_AppRouter$StoreAppPage$.prototype = $p;
$p.m = (function() {
  return "StoreAppPage";
});
$p.aS7 = (function(x$0) {
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dStore$002dApp$002dPage.$c_Lmealorama_AppRouter$StoreAppPage(x$0.g(0));
});
var $d_Lmealorama_AppRouter$StoreAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$StoreAppPage$, "mealorama.AppRouter$StoreAppPage$", ({
  Fy: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$StoreAppPage$ as $d_Lmealorama_AppRouter$StoreAppPage$ };
var $n_Lmealorama_AppRouter$StoreAppPage$;
function $m_Lmealorama_AppRouter$StoreAppPage$() {
  if ((!$n_Lmealorama_AppRouter$StoreAppPage$)) {
    $n_Lmealorama_AppRouter$StoreAppPage$ = new $c_Lmealorama_AppRouter$StoreAppPage$();
  }
  return $n_Lmealorama_AppRouter$StoreAppPage$;
}
export { $m_Lmealorama_AppRouter$StoreAppPage$ as $m_Lmealorama_AppRouter$StoreAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Store-App-Page$.js.map
